export enum TaskStatus {
  ALL = 'ALL',
  MISSED = 'MISSED',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED'
}
